import React from "react";

// Maps a raw assessment status string (snake_case, as returned by the API) to a user-friendly
// label + pill styling for the assessment listing cards.
//
// Returns null for states that should render nothing on the card:
//   - "pending"  → assigned but no questions answered yet
//   - null / unknown
//
// The three happy-path states plus the failure state are shown:
//   in_progress     → "In Progress"        (answering questions)
//   analyzing       → "Assessing"          (AI analysis running)
//   completed       → "Complete"
//   analysis_failed → "Assessment Failed"  (red — needs a retry)
export function getAssessmentStatusLabel(status) {
  switch ((status || "").toLowerCase()) {
    case "in_progress":
      return { text: "In Progress", className: "bg-blue-100 text-blue-700 border-blue-200" };
    case "analyzing":
      return { text: "Assessing", className: "bg-indigo-100 text-indigo-700 border-indigo-200" };
    case "completed":
      return { text: "Complete", className: "bg-green-100 text-green-700 border-green-200" };
    case "analysis_failed":
      return { text: "Assessment Failed", className: "bg-red-100 text-red-700 border-red-200" };
    default:
      return null; // pending / null / unrecognized → no badge
  }
}

// Small inline pill rendered next to an assessment card title (e.g. "My Org  [In Progress]").
// Renders nothing when there is no meaningful status to show.
export default function AssessmentStatusBadge({ status, className = "" }) {
  const label = getAssessmentStatusLabel(status);
  if (!label) return null;
  return (
    <span
      className={`ml-2 inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border align-middle ${label.className} ${className}`}
    >
      {label.text}
    </span>
  );
}
